import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from '@material-ui/lab/Slider';
import SkipPrevious from '@material-ui/icons/SkipPrevious';
import QueueMusic from '@material-ui/icons/QueueMusic';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Pause from '@material-ui/icons/Pause';
import SettingsIcon from '@material-ui/icons/Settings';

import { slider_classes } from '../lib/classNames';

class AbcPlayer extends PureComponent {
  static propTypes = {
    playing: PropTypes.bool.isRequired,
    duration: PropTypes.number.isRequired,
    currentTime: PropTypes.number.isRequired,
    showTutorConfigurationButton: PropTypes.bool.isRequired,
    showTutorResultButton: PropTypes.bool.isRequired,
    showOptionPopup: PropTypes.bool,
    bpm: PropTypes.number,
    bpmPlusEnabled: PropTypes.bool,
    bpmMinusEnabled: PropTypes.bool,
    bpmDelta: PropTypes.number.isRequired,
    drum: PropTypes.bool.isRequired,
    // callbacks:
    onShowTutorResultsButton: PropTypes.func,
    onShowTutorConfigurationButton: PropTypes.func,
    onCurrentTimeChanged: PropTypes.func,
    onPlayingChanged: PropTypes.func,
    onBpmChanged: PropTypes.func,
    onToggleOptions: PropTypes.func,
    onDrumChanged: PropTypes.func
  };

  render() {
    const {
      playing,
      duration,
      currentTime,
      bpm,
      bpmPlusEnabled,
      bpmMinusEnabled,
      showTutorConfigurationButton,
      showTutorResultButton,
      showOptionPopup,
      drum
    } = this.props;
    if (!bpm) return <div>Loading...</div>;
    return (
      <div id="AbcPlayer">
        <div className="RewindContainer">
          <button className="rewind" onClick={this.rewindClicked}>
            <SkipPrevious />
          </button>
        </div>
        <div className="PlayContainer">
          <button className="pauseplay" onClick={this.togglePlayClicked}>
            {playing ? <Pause /> : <PlayArrow />}
          </button>
        </div>
        <div className="TempoContainer">
          <button className={bpmPlusEnabled ? 'enabled' : 'disabled'} onClick={this.bpmPlusClicked}>
            +
          </button>
          <input type="text" value={bpm} onChange={this.bpmChanged} />
          <button className={bpmMinusEnabled ? 'enabled' : 'disabled'} onClick={this.bpmMinusClicked}>
            &minus;
          </button>
        </div>
        <div className="SliderContainer">
          <Slider
            classes={slider_classes}
            value={currentTime}
            aria-labelledby="label"
            max={duration}
            min={0}
            onChange={this.currentTimeChanged}
            disabled
          />
        </div>
        <div className="TimeContainer">
          <span>
            {this.timeToString(currentTime)}/{this.timeToString(duration)}
          </span>
        </div>
        {showTutorResultButton && (
          <div className="EndContainer" key={1}>
            <button onClick={this.toggleTutorResultsModal}>Ho finito</button>
          </div>
        )}
        {showTutorConfigurationButton && (
          <div className="TutorContainer" key={2}>
            <button onClick={this.toggleTutorConfigurationModal}>
              <SettingsIcon />
            </button>
          </div>
        )}
        <div className="DrumContainer">
          <button className={drum ? 'pressed' : ''} onClick={this.toggleDrum}>
            Metronomo
          </button>
        </div>
        {showOptionPopup && (
          <div className="OptionContainer">
            <button onClick={this.toggleOptions}>
              <QueueMusic />
            </button>
          </div>
        )}
      </div>
    );
  }

  timeToString = currentTime => {
    const seconds = Math.floor(currentTime % 60);
    const minutes = Math.floor((currentTime / 60) % 60);
    return `${minutes}:${('00' + seconds).slice(-2)}`;
  };

  rewindClicked = () => {
    if (this.props.playing) this.togglePlayClicked();
    this.resetCurreTimeChanged();
    window.dispatchEvent(new Event('rewind'));
  };

  resetCurreTimeChanged =() =>{
    this.currentTimeChanged(null, 0);
    console.log("resetting current time");
  }

  togglePlayClicked = () => {
    if (this.props.onPlayingChanged) this.props.onPlayingChanged(!this.props.playing);
  };

  currentTimeChanged = (event, value) => {
    if (this.props.onCurrentTimeChanged) this.props.onCurrentTimeChanged(value);
  };

  bpmMinusClicked = () => {
    if (this.props.onBpmChanged) this.props.onBpmChanged(this.props.bpm - this.props.bpmDelta);
  };
  bpmChanged = event => {
    console.log(event.target.value);
    if (this.props.onBpmChanged) this.props.onBpmChanged(Number(event.target.value));
  };
  bpmPlusClicked = () => {
    if (this.props.onBpmChanged) this.props.onBpmChanged(this.props.bpm + this.props.bpmDelta);
  };

  toggleTutorResultsModal = () => {
    if (this.props.onShowTutorResultsButton) this.props.onShowTutorResultsButton();
  };

  toggleTutorConfigurationModal = () => {
    if (this.props.onShowTutorConfigurationButton) this.props.onShowTutorConfigurationButton();
  };

  toggleOptions = event => {
    if (this.props.onToggleOptions) this.props.onToggleOptions(document.querySelector('.OptionContainer'));
  };

  toggleDrum = event => {
    event.target.classList.toggle('pressed');
    if (this.props.onDrumChanged) this.props.onDrumChanged(event.target.classList.contains('pressed'));
  };
}

export default AbcPlayer;
